import React from 'react';
import { scaleLinear } from 'd3-scale';

import './Dashboard.css';

export const defaultScale = scaleLinear().domain([0, 20]).range([170, 0]);

function YAxis({ scale = defaultScale, ticks, tickFormat = f => f, legend }) {
  const tickValues = ticks ? Object.values(ticks) : scale.ticks();
  return (
    <g className="y-axis">
      {
        tickValues.map(tick => (
          <g key={tick} transform={`translate(0,${scale(tick)})`}>
            <line vectorEffect="non-scaling-stroke" x2="721" />
            <text dx="-6" dy="0.35em">{tickFormat(tick)}</text>
          </g>
        ))
      }
      {legend}
    </g>
  );
}

export default YAxis;
